<div class="co-modal" *ngIf="modal.open" (click)="closeModal($event)">
  <div class="co-modal__content" (click)="preventClosing($event)">
    <i class="co-modal__close" (click)="closeModal($event)"
      ><svg viewBox="0 0 24 24">
        <path
          fill="#000000"
          d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
        />
      </svg>
    </i>
    <h3 class="modal-title" *ngIf="modal.type === 'emptyCart'">
      Auswahl unvollständig
    </h3>
    <div
      [innerHTML]="modal.content"
      [ngClass]="{ 'co-modal__error': modal.type === 'emptyCart' }"
    ></div>
  </div>
</div>
